import * as firebase from "firebase/app";
import {getAuth} from "firebase/auth";

export const config = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_DB,
  projectId: process.env.REACT_APP_PID,
  storageBucket: process.env.REACT_APP_SB,
  messagingSenderId: process.env.REACT_APP_SID,
  appId: process.env.REACT_APP_APP_ID,
};
export const app = firebase.initializeApp(config);
export const auth = getAuth(app);
